const DIAGRAM_MIME = 'application/x-gantt-diagram-id';

export function setDraggedDiagramId(e: React.DragEvent, id: string) {
  e.dataTransfer.setData(DIAGRAM_MIME, id);
  e.dataTransfer.effectAllowed = 'move';
}

export function getDraggedDiagramId(e: React.DragEvent): string | null {
  return e.dataTransfer.getData(DIAGRAM_MIME) || null;
}

export function isDiagramDrag(e: React.DragEvent): boolean {
  return e.dataTransfer.types.includes(DIAGRAM_MIME);
}

/** Un déplacement déclenché depuis l'arborescence latérale peut affecter le dossier actuellement affiché ailleurs dans l'UI. */
export const DIAGRAM_MOVED_EVENT = 'gantt:diagram-moved';

export function notifyDiagramMoved() {
  window.dispatchEvent(new CustomEvent(DIAGRAM_MOVED_EVENT));
}
